import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const useApplicationSearchParam = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const applicationParam = searchParams.get('application');

  const isApplicationParamPresent = applicationParam === 'true';

  const injectApplicationParam = useCallback(() => {
    if (!isApplicationParamPresent) {
      searchParams.set('application', 'true');
      navigate({ search: searchParams.toString() }, { replace: true });
    }
  }, [applicationParam, navigate, searchParams]);

  return { isApplicationParamPresent, injectApplicationParam };
};
